import React from "react";

// ============================================================================
// FUNCIONES HELPER PARA ESTILOS
// ============================================================================

/**
 * Genera estilos para el nombre del jugador
 * @param {string} nameColor - Color del nombre (hex, CSS var, o undefined)
 * @returns {Object} Objeto de estilos con color
 */
function getNameStyle(nameColor) {
  return nameColor ? { color: nameColor } : { color: "var(--color-black)" };
}

/**
 * Genera estilos para el apellido del jugador
 * @param {string} lastNameColor - Color del apellido (hex, CSS var, o undefined)
 * @returns {Object} Objeto de estilos con color
 */
function getLastNameStyle(lastNameColor) {
  return lastNameColor ? { color: lastNameColor } : { color: "var(--color-black)" };
}

// ============================================================================
// COMPONENTE PLAYERNAME
// ============================================================================

/**
 * Renderiza el nombre del jugador o el número del slot
 * 
 * Componente memoizado que muestra:
 * - Si hay jugador: nombre y apellido con colores personalizados
 * - Si no hay jugador: número del slot
 * 
 * @component
 * @param {Object|null} player - Jugador asignado
 * @param {string} player.firstName - Primer nombre del jugador
 * @param {string} player.lastName - Apellido del jugador
 * 
 * @param {string} [nameColor] - Color del nombre (hex o CSS var)
 * @param {string} [lastNameColor] - Color del apellido (hex o CSS var)
 * @param {number} slotNumber - Número del slot (mostrado si no hay jugador)
 * 
 * @returns {JSX.Element} Span con el nombre del jugador o número del slot
 */
const PlayerName = React.memo(function PlayerName({ player, nameColor, lastNameColor, slotNumber }) {
  if (!player) {
    return <span className="player-slot__name">{slotNumber}</span>;
  }

  return (
    <span className="player-slot__name">
      <span style={getNameStyle(nameColor)}>{String(player.firstName).toUpperCase().charAt(0)}.</span>
      {" "}
      <span style={getLastNameStyle(lastNameColor)}>{player.lastName}</span>
    </span>
  );
});

export default PlayerName;